module.exports = __webpack_public_path__ + "img/loading.976334f0.gif";